import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './CancelPage.css';
import PurchaseFeedback from '../components/PurchaseFeedback';
import { handleAnalyticsEvent } from '../helpers/analyticsHandler';

function CancelPage() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        handleAnalyticsEvent('checkout_canceled', 'checkout', 'return');
        // Clear any payment-related localStorage items
        localStorage.removeItem('pendingPayment');
        localStorage.removeItem('checkoutSessionId');
    }, []);

    const handleTryAgain = () => {
        navigate('/pricing');
    };

    const handleBackToHome = () => {
        navigate('/');
    };

    const handleContactSupport = () => {
        // You can modify this to open a contact form or redirect to support
        window.open('mailto:support@facadewebapp.com', '_blank');
    };

    return (
        <div className="cancel-page">
            <div className="cancel-container">
                <div className="cancel-icon">
                    <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
                        <circle cx="40" cy="40" r="40" fill="#EF4444"/>
                        <path d="M30 30L50 50M50 30L30 50" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>

                <h1 className="cancel-title">{t('payment.cancel.title')}</h1>
                <p className="cancel-message">
                    {t('payment.cancel.message')}
                </p>

                <div className="cancel-reasons">
                    <h3>{t('payment.cancel.reasons.title')}</h3>
                    <ul>
                        <li>{t('payment.cancel.reasons.userCancelled')}</li>
                        <li>{t('payment.cancel.reasons.cardDeclined')}</li>
                        <li>{t('payment.cancel.reasons.sessionExpired')}</li>
                    </ul>
                </div>

                <div className="cancel-actions">
                    <button 
                        className="btn btn-primary btn-lg"
                        onClick={handleTryAgain}
                    >
                        {t('payment.cancel.actions.tryAgain')}
                    </button>
                    <button 
                        className="btn btn-outline-secondary btn-lg"
                        onClick={handleBackToHome}
                    >
                        {t('payment.cancel.actions.backToHome')}
                    </button>
                </div>

                <PurchaseFeedback placement="checkout_cancel" />

                <div className="cancel-support">
                    <p>{t('payment.cancel.help')}</p>
                    <button 
                        className="btn btn-link"
                        onClick={handleContactSupport}
                    >
                        {t('payment.cancel.actions.contactSupport')}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default CancelPage;
